/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
	fetch({ commit }) {
		commit('FETCH_WORKERS')
		return new Promise((resolve, reject) => {
			axios.get("/api/workers/list")
				.then((response) => {
					console.log('set workers');
					commit('SET_WORKERS', response.data)
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	save({ commit }, item) {
		return new Promise((resolve, reject) => {
			axios.post('/api/workers/create', item)
				.then((response) => {
					console.log(response.data);
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	update({ commit }, item) {
		return new Promise((resolve, reject) => {
			axios.post('/api/workers/update/' + item.id, item)
				.then((response) => {
					console.log(response.data);
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	delete({ commit }, id) {
		return new Promise((resolve, reject) => {
			axios.delete(`/api/workers/delete/${id}`)
				.then((response) => {
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
}
